{
  "basic2p": {
    "id": "basic2p",
    "name": "BASIC BLASTER",
    "slot": 1,
    "category": "kinetic",
    "ammoType": "energy",
    "ammoCost": 2,
    "ammoCostPerShot": 2,
    "fireRate": 5.0,
    "damage": 20,
    "projectileSpeed": 60,
    "projectileCount": 1,
    "spreadAngle": 0,
    "spread": 0,
    "gravity": 0,
    "bounces": 0,
    "homing": false,
    "penetrating": false,
    "aoeRadius": 0,
    "splashRadius": 0,
    "color": 65535,
    "size": [0.1, 0.1, 0.6],
    "muzzleOffset": [0, 0, 0],
    "range": 240
  },
  "blade": {
    "id": "blade",
    "name": "A.R.C. BLADE",
    "slot": 2,
    "category": "melee",
    "ammoType": "none",
    "ammoCost": 0,
    "ammoCostPerShot": 0,
    "fireRate": 2.5,
    "damage": 60,
    "projectileSpeed": 30,
    "projectileCount": 1,
    "spreadAngle": 0,
    "spread": 0,
    "gravity": 0,
    "bounces": 0,
    "homing": false,
    "penetrating": true,
    "aoeRadius": 0,
    "splashRadius": 0,
    "color": 65416,
    "size": [0.3, 0.05, 1.2],
    "muzzleOffset": [0, 0, 0],
    "range": 120
  },
  "spread1p": {
    "id": "spread1p",
    "name": "SPREAD GUN",
    "slot": 3,
    "category": "kinetic",
    "ammoType": "spread",
    "ammoCost": 1,
    "ammoCostPerShot": 1,
    "fireRate": 2.0,
    "damage": 15,
    "projectileSpeed": 50,
    "projectileCount": 5,
    "spreadAngle": 0.12,
    "spread": 0.12,
    "gravity": 0,
    "bounces": 0,
    "homing": false,
    "penetrating": false,
    "aoeRadius": 0,
    "splashRadius": 0,
    "color": 16724736,
    "size": [0.08, 0.08, 0.3],
    "muzzleOffset": [0, 0, 0],
    "range": 200
  },
  "plasma": {
    "id": "plasma",
    "name": "PLASMA CANNON",
    "slot": 4,
    "category": "energy",
    "ammoType": "energy",
    "ammoCost": 15,
    "ammoCostPerShot": 15,
    "fireRate": 1.5,
    "damage": 75,
    "projectileSpeed": 35,
    "projectileCount": 1,
    "spreadAngle": 0,
    "spread": 0,
    "gravity": 0,
    "bounces": 0,
    "homing": false,
    "penetrating": false,
    "aoeRadius": 2.5,
    "splashRadius": 2.5,
    "color": 11141375,
    "size": [0.35, 0.35, 0.35],
    "muzzleOffset": [0, 0, 0],
    "range": 140
  },
  "beamp": {
    "id": "beamp",
    "name": "LASER BEAM",
    "slot": 5,
    "category": "energy",
    "ammoType": "energy",
    "ammoCost": 5,
    "ammoCostPerShot": 5,
    "fireRate": 10.0,
    "damage": 12,
    "projectileSpeed": 120,
    "projectileCount": 1,
    "spreadAngle": 0,
    "spread": 0,
    "gravity": 0,
    "bounces": 0,
    "homing": false,
    "penetrating": true,
    "aoeRadius": 0,
    "splashRadius": 0,
    "color": 35071,
    "size": [0.08, 0.08, 1.5],
    "muzzleOffset": [0, 0, 0],
    "range": 480
  },
  "miss1p": {
    "id": "miss1p",
    "name": "DUMBFIRE ROCKET",
    "slot": 6,
    "category": "explosive",
    "ammoType": "missile",
    "ammoCost": 1,
    "ammoCostPerShot": 1,
    "fireRate": 1.2,
    "damage": 90,
    "projectileSpeed": 40,
    "projectileCount": 1,
    "spreadAngle": 0,
    "spread": 0,
    "gravity": 0,
    "bounces": 0,
    "homing": false,
    "penetrating": false,
    "aoeRadius": 3.5,
    "splashRadius": 3.5,
    "color": 16755200,
    "size": [0.18, 0.18, 0.7],
    "muzzleOffset": [0, 0, 0],
    "range": 160
  },
  "homing1p": {
    "id": "homing1p",
    "name": "HOMING MISSILE",
    "slot": 7,
    "category": "explosive",
    "ammoType": "missile",
    "ammoCost": 1,
    "ammoCostPerShot": 1,
    "fireRate": 1.0,
    "damage": 70,
    "projectileSpeed": 32,
    "projectileCount": 1,
    "spreadAngle": 0,
    "spread": 0,
    "gravity": 0,
    "bounces": 0,
    "homing": true,
    "penetrating": false,
    "aoeRadius": 2.8,
    "splashRadius": 2.8,
    "color": 16733440,
    "size": [0.15, 0.15, 0.6],
    "muzzleOffset": [0, 0, 0],
    "range": 128
  },
  "gyrex1p": {
    "id": "gyrex1p",
    "name": "GYREX LAUNCHER",
    "slot": 8,
    "category": "explosive",
    "ammoType": "gyrex",
    "ammoCost": 1,
    "ammoCostPerShot": 1,
    "fireRate": 1.8,
    "damage": 65,
    "projectileSpeed": 30,
    "projectileCount": 1,
    "spreadAngle": 0,
    "spread": 0,
    "gravity": -12.0,
    "bounces": 3,
    "homing": false,
    "penetrating": false,
    "aoeRadius": 3.0,
    "splashRadius": 3.0,
    "color": 3407667,
    "size": [0.25, 0.25, 0.25],
    "muzzleOffset": [0, 0, 0],
    "range": 120
  },
  "rail": {
    "id": "rail",
    "name": "RAILGUN",
    "slot": 9,
    "category": "kinetic",
    "ammoType": "energy",
    "ammoCost": 25,
    "ammoCostPerShot": 25,
    "fireRate": 0.8,
    "damage": 150,
    "projectileSpeed": 200,
    "projectileCount": 1,
    "spreadAngle": 0,
    "spread": 0,
    "gravity": 0,
    "bounces": 0,
    "homing": false,
    "penetrating": true,
    "aoeRadius": 0,
    "splashRadius": 0,
    "color": 16777215,
    "size": [0.06, 0.06, 3.0],
    "muzzleOffset": [0, 0, 0],
    "range": 800
  },
  "cannon1p": {
    "id": "cannon1p",
    "name": "HEAVY CANNON",
    "slot": 10,
    "category": "kinetic",
    "ammoType": "cannon",
    "ammoCost": 1,
    "ammoCostPerShot": 1,
    "fireRate": 1.5,
    "damage": 100,
    "projectileSpeed": 75,
    "projectileCount": 1,
    "spreadAngle": 0,
    "spread": 0,
    "gravity": -4.0,
    "bounces": 0,
    "homing": false,
    "penetrating": false,
    "aoeRadius": 1.5,
    "splashRadius": 1.5,
    "color": 16768324,
    "size": [0.2, 0.2, 0.8],
    "muzzleOffset": [0, 0, 0],
    "range": 300
  },
  "subdue": {
    "id": "subdue",
    "name": "SUBDUE EMP",
    "slot": 11,
    "category": "special",
    "ammoType": "energy",
    "ammoCost": 20,
    "ammoCostPerShot": 20,
    "fireRate": 1.2,
    "damage": 30,
    "projectileSpeed": 45,
    "projectileCount": 1,
    "spreadAngle": 0,
    "spread": 0,
    "gravity": 0,
    "bounces": 0,
    "homing": false,
    "penetrating": false,
    "aoeRadius": 3.0,
    "splashRadius": 3.0,
    "color": 48127,
    "size": [0.28, 0.28, 0.28],
    "muzzleOffset": [0, 0, 0],
    "range": 180
  }
}
